'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('new', {
        url: '/new',
        template: '<new></new>'
    });
}



// WEBPACK FOOTER //
// ./client/app/new/new.routes.js